import { Action } from 'graphql/types.generated'

import { getPermissionReterritorializarAction } from '../../reterritorializacao/utils/reterritorializacao'
import { toImovelItemModel } from '../converter-inativacaoImoveis'
import { InativacaoImovelActionModel } from '../model-inativacaoImoveis'

export const imovelComFamiliaAction = {
  enabled: false,
  hint: 'Não é possível inativar imóveis com famílias',
}

export const getPermissionInativarImovelAction = (imovelDto: InativacaoImovelActionModel): Action =>
  imovelDto.familias.length > 0
    ? imovelComFamiliaAction
    : getPermissionReterritorializarAction(toImovelItemModel(imovelDto))

export const imoveisSelecionadosTitle = (numImoveis: number) =>
  `${numImoveis} imóve${numImoveis === 1 ? 'l selecionado' : 'is selecionados'} para inativação`

export const getInativacaoImoveisTopic = (progressToken: string) => `inativacaoImoveis/${progressToken}`
